import template from './CounterChildCardView.html';
import * as styles from './counterChildCard.scss';
class CounterChildCardController {
    static $inject = ['$element', '$timeout'];
    constructor($element, $timeout) {
        'ngInject';
        this.$element = $element;
        this.$timeout = $timeout;
        this.styles = styles;
    }
}
CounterChildCardController.$inject = ['$element', '$timeout'];
const CounterChildCardComponent = {
    template,
    controller: CounterChildCardController,
    controllerAs: '$ctrl',
    bindings: {
        name: '<',
        value: '<',
        tooltip: '<',
        loaded: '<',
    },
};
export default CounterChildCardComponent;
